export default "__VITE_PUBLIC_ASSET__87c8b866__"